import React from "react";
import { observer } from "mobx-react";
import { MusicalWorkLinkUpdateStore } from "../../store";
import { MusicalWorkLinkUpdateForm } from "./MusicalWorkLinkUpdateForm";
import { ErrorDialog, ConfirmCancelDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type MusicalWorkLinkUpdateProps = {
  musicalWorkLinkUpdateStore: MusicalWorkLinkUpdateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const MusicalWorkLinkUpdate: React.FC<MusicalWorkLinkUpdateProps> =
  observer(
    ({ musicalWorkLinkUpdateStore, showToolbox = true, showSaveFooter }) => {
      return (
        <>
          <SavingOverlay open={musicalWorkLinkUpdateStore.isSaving} />
          <MusicalWorkLinkUpdateForm
            musicalWorkLinkUpdateStore={musicalWorkLinkUpdateStore}
            urlError={musicalWorkLinkUpdateStore.errors.url?.message}
            onUrlChange={(value: string) => {
              musicalWorkLinkUpdateStore.setUrlValue(value);
            }}
            url={musicalWorkLinkUpdateStore.entityValues.url}
            platformError={musicalWorkLinkUpdateStore.errors.platform?.message}
            onPlatformChange={(value) => {
              musicalWorkLinkUpdateStore.setPlatformValue(value);
            }}
            platformSelectedValue={
              musicalWorkLinkUpdateStore.entityValues.showPlatform
            }
            onPlatformSelected={(value) => {
              musicalWorkLinkUpdateStore.setSelectedPlatform(value);
            }}
            platformOptions={musicalWorkLinkUpdateStore.getPlatformOptions()}
            typeError={musicalWorkLinkUpdateStore.errors.type?.message}
            onTypeChange={(value) => {
              musicalWorkLinkUpdateStore.setTypeValue(value);
            }}
            typeSelectedValue={musicalWorkLinkUpdateStore.entityValues.showType}
            onTypeSelected={(value) => {
              musicalWorkLinkUpdateStore.setSelectedType(value);
            }}
            typeOptions={musicalWorkLinkUpdateStore.getTypeOptions()}
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={musicalWorkLinkUpdateStore.saveDisabled}
            onSave={() => musicalWorkLinkUpdateStore.saveMusicalWorkLink()}
            onCancel={() => musicalWorkLinkUpdateStore.cancelMusicalWorkLink()}
          />
          <ErrorDialog
            open={musicalWorkLinkUpdateStore.errorDialogOpened}
            title={musicalWorkLinkUpdateStore.errorTitle}
            description={musicalWorkLinkUpdateStore.errorDescription}
            onClose={() => musicalWorkLinkUpdateStore.closeErrorDialog()}
          />
          <ConfirmCancelDialog
            open={musicalWorkLinkUpdateStore.confirmDialogOpened}
            title={musicalWorkLinkUpdateStore.confirmDialogTitle}
            description={musicalWorkLinkUpdateStore.confirmDialogDescription}
            onConfirm={() =>
              musicalWorkLinkUpdateStore.executeConfirmedAction()
            }
            onCancel={() => musicalWorkLinkUpdateStore.closeConfirmDialog()}
          />
        </>
      );
    }
  );
